import { StartListeningOptions } from './listenerMiddlewareTypes';
import { loadCardPage } from '../view/thunks';
import { isAnyOf } from '@reduxjs/toolkit';

export const listOnRejectListener: StartListeningOptions = {
  predicate: loadCardPage.rejected.match,
  effect: action => {
    if (!isAnyOf(loadCardPage.rejected)(action)) return; // to get proper types
  },
};
